import { Pipe, PipeTransform } from "@angular/core";

@Pipe({ name: 'numerize' })
export class NumerizePipe implements PipeTransform {

    transform(value: any, cerosDecimales: number) {
        if (value) {
            // agregar ceros despues de la coma
            let whitCeros = value.toFixed(cerosDecimales);

            // agregar punto cada 3 cifras
            var numero = this.commafy(whitCeros);

            // reemplazar '.' por ',' y ',' por '.'
            return numero.replace(/,/g, '|').replace('.', ',').replace(/\|/g, '.');
        }

        return value;
    }

    commafy(num) {
        var str = num.toString().split('.');
        if (str[0].length >= 4) {
            str[0] = str[0].replace(/(\d)(?=(\d{3})+$)/g, '$1,');
        }
        if (str[1] && str[1].length >= 4) {
            str[1] = str[1].replace(/(\d{3})/g, '$1 ');
        }
        return str.join('.');
    }
}